export default "__VITE_ASSET__55cd1de8__"